// extracted by mini-css-extract-plugin
module.exports = {"Footer":"RelatedEducationalActivities_Footer__2XQv9"};